// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tooltip-inner{max-width:unset!important}", "",{"version":3,"sources":["webpack://./resources/js/Components/Customers/Contracts/ContractListItem.vue"],"names":[],"mappings":"AACA,eAAA,yBAAA","sourcesContent":["\n.tooltip-inner {max-width: unset !important}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
